"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _BusinessTypeDialog = _interopRequireDefault(require("./components/BusinessTypeDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BusinessTypeList',
  components: {
    BusinessTypeDialog: _BusinessTypeDialog.default
  },
  data: function data() {
    return {
      listPram: {},
      treeData: [],
      listLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    // 根据type值获取店铺类型名称
    getTypeName: function getTypeName(type) {
      var typeMap = {
        1: '实物',
        2: '团购',
        3: '酒店'
      };
      return typeMap[type] || "\u5E97\u94FA\u7C7B\u578B".concat(type);
    },
    hasBackendId: function hasBackendId(row) {
      if (!row || row.isParent) return false;
      var id = row.id;
      if (id === null || id === undefined || id === '') return false;
      return Number(id) !== 0 && !Number.isNaN(Number(id));
    },
    // 将后端返回的对象格式转换为树形结构
    convertToTree: function convertToTree(data) {
      var _this = this;
      if (!data || _typeof(data) !== 'object') {
        return [];
      }
      var treeData = [];
      // 遍历对象的每个key（店铺类型type）
      Object.keys(data).forEach(function (type) {
        var children = data[type] || [];
        if (children.length > 0) {
          // 创建父节点
          var parentNode = {
            id: "parent-".concat(type),
            rowKey: "parent-".concat(type),
            type: parseInt(type),
            name: _this.getTypeName(parseInt(type)),
            isParent: true,
            children: children.map(function (item, index) {
              return _objectSpread(_objectSpread({}, item), {}, {
                isParent: false,
                rowKey: "child-".concat(type, "-").concat(index)
              });
            })
          };
          treeData.push(parentNode);
        }
      });
      return treeData;
    },
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      this.listLoading = true;
      (0, _rsManagement.getBusinessTypeList)(this.listPram).then(function (res) {
        // 后端返回的data是对象格式
        var data = res.data || res;
        _this2.treeData = _this2.convertToTree(data);
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      this.$refs.businessTypeDialogRef.open({});
    },
    handleEdit: function handleEdit(row) {
      // 编辑时，需要将整个店铺类型下的所有店铺类型数据传给弹框
      // row 是父节点，包含 children 数组
      var editData = {
        id: row.type,
        // id字段就是type的值
        type: row.type,
        storeTypes: row.children || [],
        allData: this.treeData // 传递所有数据，用于选择type后渲染已有值
      };
      this.$refs.businessTypeDialogRef.open(editData);
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5E97\u94FA\u7C7B\u578B\"".concat(row.name, "\"\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _rsManagement.deleteBusinessType)(row.id).then(function () {
          _this3.$message.success('删除成功');
          _this3.handlerGetListData();
        }).catch(function () {
          _this3.$message.error('删除失败');
        });
      });
    }
  }
};